require('./componentStyles/securepayStyles.css')

import * as React from 'react';
import update from 'immutability-helper';
import { cssRaw } from 'typestyle';
import { PrimaryButton } from '../../ap/base/button';
import { Hr } from '../../ap/base/hr';
import * as gls from '../../ap/layout/gls';
import * as alerts from '../../ap/base/alerts';
import { trackLinkClick } from '../../ap/omniture/omnitureService';

type SecurepayInstance = {
  tokenise: () => void;
}

declare var securePayUI: {
  init: {
    new(config: any): SecurepayInstance
  }
}


export type SecurepayScheme = 'visa' | 'mastercard';

export type SecurepayCreditCard = {
  token: string,
  scheme: SecurepayScheme,
  last4: string,
  customer?: string
};


interface SecurepayState {
  paymentInProgress: boolean;
  errorMessage: string;
}

interface SecurepayProps{
  clientId: string;
  merchantCode: string;
  scriptUrl: string;
  servicePrice: number;
  cancelUrl: string;
  allowedCardTypes: SecurepayScheme[];

  onFormValidityChange: (valid: boolean) => void;
  onTokenizeSuccess: (creditCard: SecurepayCreditCard) => void;
  onTokenizeError: (errorMessage?: string) => void;
  onLoadError: () => void;
}

export class Securepay extends React.Component<SecurepayProps, SecurepayState>{

  validForm;
  initialLoading;
  securepayInstance: SecurepayInstance;

  constructor(props) {
    super(props);
    this.state = {paymentInProgress: false, errorMessage: null};
    this.validForm = false;
    this.doPay = this.doPay.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  static iframeContainerId = 'securepay-ui-container';

  /** Fix the layout for securepay iframe */
  static loadCSS = cssRaw(`
#${Securepay.iframeContainerId} iframe {
  min-height: 180px;
  border: none;
  width: 100%;
}
`);

  handleError = (errors) => {
    console.log(errors)
    this.updateState({paymentInProgress: false});
    this.props.onTokenizeError(errors);
  }

  componentDidMount() {
    this.initialLoading = true;
    const secuepayScriptId = 'securepay-ui-js';
    loadScriptOnce(this.props.scriptUrl, secuepayScriptId)
      .then(() => {
        if (!securePayUI) {
          this.props.onLoadError();
          return;
        }
        this.securepayInstance = new securePayUI.init({
          containerId: Securepay.iframeContainerId,
          scriptId: 'securepay-ui-js',
          clientId: this.props.clientId,
          merchantCode: this.props.merchantCode,
          card: {
            allowedCardTypes: this.props.allowedCardTypes,
            showCardIcons: true,
            onFormValidityChange: (valid: boolean) => {
              this.validForm = valid;
              this.formValidationAlert(valid);
              this.props.onFormValidityChange(valid);
            },
            onTokeniseSuccess: (tokenisedCard: any) => {
              this.props.onTokenizeSuccess(tokenisedCard);
            },
            onTokeniseError: (errors) => {
              this.handleError(errors);
            }
          },
        })
      })
  }

  render() {
    const omnitureOnClickCancel = () => trackLinkClick('diy register', 'payment:cancel');

    return(
      <div style={{textAlign: 'center'}}>
        <gls.ContentHorizontalMargined>
          <span>Secure payment</span>
        </gls.ContentHorizontalMargined>
        <gls.SmallVerticalSpace space={20} />
        <Hr/>
        <gls.SmallVerticalSpace space={20} />
        <gls.SmallVerticalSpace space={20} />
        <div id={Securepay.iframeContainerId} />
        <gls.ContentHorizontalMargined>
          <span>Total to pay</span>
          <gls.Flex />
          <span>$ {this.props.servicePrice}</span>
        </gls.ContentHorizontalMargined>
        <gls.SmallVerticalSpace space={20} />
        <Hr/>
        <gls.SmallVerticalSpace space={20} />

        {
          this.state.errorMessage?
          <div>
            <alerts.Alert type={alerts.AlertType.Error}>
              {this.state.errorMessage}
            </alerts.Alert>
            < gls.SmallVerticalSpace space={20}/>
          </div>
            :
            <div></div>
        }

        <gls.ContentHorizontalMargined>
          <a href={this.props.cancelUrl} onClick={omnitureOnClickCancel}>Cancel</a>
          <gls.Flex />
          <PrimaryButton id="payButton" text="Pay" onClick={this.doPay} loading={this.state.paymentInProgress}/>
        </gls.ContentHorizontalMargined>
      </div>);
  }


  private doPay(){
    this.updateState({paymentInProgress: true});
    this.updateState({errorMessage: null});
    this.securepayInstance.tokenise();
  }

  paymentErrorAlert(message){
    this.updateState({paymentInProgress: false});
    this.updateState({errorMessage: message});
  }

  private updateState(newPropVal){
    this.setState((currentState) => {
      return update(currentState, {$merge: newPropVal});
    });
  }

  private formValidationAlert(valid) {
    if(this.initialLoading){
      this.initialLoading = false;
      return;
    }

    if(this.validForm) {
      this.updateState({errorMessage: null});
      return;
    }

    this.updateState({errorMessage: "Invalid Card Details."});
  }
}

/**
 * Only loads a given scriptUrl once on demand
 */
const {loadScriptOnce} = new class {
  private alreadyLoaded: { [url: string]: Promise<{ script: HTMLScriptElement }> } = Object.create(null);
  loadScriptOnce = (scriptUrl: string, scriptId: string) => {
    if (!this.alreadyLoaded[scriptUrl]) {
      this.alreadyLoaded[scriptUrl] = this.include(scriptUrl, scriptId);
    }
    return this.alreadyLoaded[scriptUrl];
  }
  /**
  * Utility : Resolves when a script has been loaded
  */
  include = (url: string, id?: string) => {
    return new Promise<{ script: HTMLScriptElement }>((resolve, reject) => {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.id = id;

      script.onload = function() {
        resolve({ script });
      };

      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }
}

